module.exports = __webpack_public_path__ + "img/lenovo.4e8c2f29.png";